/**
 * Copy automatically a given string to the clipboard
 * @param str to copy to the clipboard
 */
const copyToClipboard = (str: string) => {
  const el = document.createElement('textarea');
  el.value = str;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';

  // The modal has an overlay which prevents the selection of elements that are not within
  const container = document.querySelector('#modalContent') || document.body;
  container.appendChild(el);
  el.select();
  document.execCommand('copy');
  container.removeChild(el);
};

export default copyToClipboard;
